import { render, staticRenderFns } from "./copyButton.vue?vue&type=template&id=2921fc4a"
import script from "./copyButton.vue?vue&type=script&lang=js"
export * from "./copyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports